export const primaryNav = [
  { label: 'Services', href: '/services' },
  { label: 'Industries', href: '/industries' },
  { label: 'Products', href: '/products' },
  { label: 'Cases', href: '/cases' },
  { label: 'Insights', href: '/insights' },
] as const

export const companyNav = [
  { label: 'About', href: '/about' },
  { label: 'Careers', href: '/careers' },
  { label: 'Contact', href: '/contact' },
] as const

export const footerServiceLinks = [
  { label: 'Product & Web', href: '/services/product-and-web' },
  { label: 'Software', href: '/services/software' },
  { label: 'Mobile', href: '/services/mobile' },
  { label: 'AI & Intelligence', href: '/services/ai-and-intelligence' },
  { label: 'Brand & Digital Identity', href: '/services/brand-and-digital-identity' },
  { label: 'Product Strategy', href: '/services/product-strategy' },
] as const

export const footerIndustryLinks = [
  { label: 'Business & Professional Services', href: '/industries/business-and-professional-services' },
  { label: 'Automotive', href: '/industries/automotive' },
  { label: 'Real Estate', href: '/industries/real-estate' },
  { label: 'Hospitality', href: '/industries/hospitality' },
  { label: 'Commerce & Retail', href: '/industries/commerce-and-retail' },
  { label: 'Institutions', href: '/industries/institutions' },
] as const

export const footerProductLinks = [
  { label: 'Jokor', href: '/products#jokor' },
  { label: 'CarNerx', href: '/products#carnerx' },
  { label: 'Products in Development', href: '/products#in-development' },
] as const

export const footerCompanyLinks = [
  { label: 'About', href: '/about' },
  { label: 'Cases', href: '/cases' },
  { label: 'Insights', href: '/insights' },
  { label: 'Careers', href: '/careers' },
  { label: 'Contact', href: '/contact' },
] as const

export const socialLinks = [
  { label: 'Instagram', href: 'https://www.instagram.com/limitlast8/' },
  { label: 'Facebook', href: 'https://www.facebook.com/limitlast/' },
  { label: 'LinkedIn', href: 'https://gm.linkedin.com/company/limitlast8' },
] as const

export const contactDetails = {
  email: 'contact@limitlast.co',
  phones: ['+220 223 4798', '+220 360 9050'],
}
